export const EXAM_STATUSES = {
  approved: "approved",
  rejected: "rejected",
  notApplicable: "na",
  expired: "expired",
};
